import type { PropsWithChildren } from "react";
import { createContext, useCallback, useContext, useState } from "react";
import { EnterpriseContactModal } from "./contact-us-modal";
import { EnterpriseContactData } from "./types";

const EnterpriseContactServiceContext = createContext<(data?: EnterpriseContactData) => Promise<boolean>>(
  Promise.reject
);

// eslint-disable-next-line react-refresh/only-export-components
export const useContactUs = () => useContext(EnterpriseContactServiceContext);

export const EnterpriseContactServiceProvider = ({ children }: PropsWithChildren) => {
  const [open, setOpen] = useState<boolean>(false);

  const [data, setData] = useState<EnterpriseContactData>();

  const [awaitingPromise, setAwaitingPromise] = useState<{
    reject: () => void;
    resolve: (confirmed: boolean) => void;
  }>();

  const openEnterpriseContact = useCallback(
    (data?: EnterpriseContactData) => {
      setData(data);
      setOpen(true);
      return new Promise<boolean>((resolve, reject) => {
        setAwaitingPromise({ reject, resolve });
      });
    },
    [setAwaitingPromise, setOpen]
  );

  const handleClose = () => {
    if (awaitingPromise) {
      awaitingPromise.resolve(false);
    }

    setOpen(false);
  };

  const handleSubmit = () => {};

  return (
    <>
      <EnterpriseContactServiceContext.Provider value={openEnterpriseContact}>
        {children}
      </EnterpriseContactServiceContext.Provider>
      {open && <EnterpriseContactModal isOpen={open} data={data} onClose={handleClose} onSubmit={handleSubmit} />}
    </>
  );
};
